import {
    getGetTestingActivitiesTestingActivityIdQueryKey,
    useGetTestingActivitiesTestingActivityIdSuspense,
} from "../../../../../api/generated/testing-activities/testing-activities";

export const getTestingActivityQueryKey =
    getGetTestingActivitiesTestingActivityIdQueryKey;

export function useTestingActivitySuspenseQuery(id: string) {
    return useGetTestingActivitiesTestingActivityIdSuspense(id, {
        query: { select: (response) => response.data },
    });
}
